import {
  SEND_EMAIL,
  SEND_EMAIL_SUCCESS,
  SEND_EMAIL_FAILURE,
} from 'constants/ActionTypes';
import { custom } from 'utils/Api';

export const sendEmail = () => ({
  type: SEND_EMAIL,
});

export const sendEmailSuccess = email => ({
  type: SEND_EMAIL_SUCCESS,
  email,
});

export const sendEmailFailure = error => ({
  type: SEND_EMAIL_FAILURE,
  error,
});
const readFiles = file => new Promise((resolve) => {
  const reader = new FileReader();
  reader.onload = () => {
    const base64Data = reader.result.split(',')[1];
    const attachment = {
      Name: file.name,
      Data: base64Data,
    };
    resolve(attachment);
  };
  reader.readAsDataURL(file);
});

export const requestSendEmail = ({
  Attachments,
  From,
  To,
  Body,
  Subject,
}, idCallBack) =>
  (dispatch, getState) => {
    dispatch(sendEmail());
    const {
      loginReducer: { token },
    } = getState();
    const attachments = [];
    const promises = Array.from(Attachments).map(file => new Promise((resolve) => {
      readFiles(file)
        .then((attachment) => {
          attachments.push(attachment);
          resolve(attachment);
        });
    }));
    Promise.all(promises).then(() => {
      console.log(attachments, 'attachments');
      const configMail = {
        headers: { Authorization: `Bearer ${token}` },
        method: 'POST',
        url: '/api/QDataEmail/SendEmail',
        data: {
          From,
          ToList: To,
          Body,
          Subject,
          Attachments: attachments,
          AutoFillIfEmpty: 'true',
        },
        maxBodyLength: 30 * 1024 * 1024,
        maxContentLength: 30 * 1024 * 1024,
      };
      custom(configMail)
        .then((res) => {
          dispatch(sendEmailSuccess(res.data));
          if (idCallBack) {
            idCallBack(res.data);
          }
        })
        .catch(err => dispatch(sendEmailFailure(err)));
    });
  };




// WEBPACK FOOTER //
// ./src/actions/Email.js